'use client';

import HinweisZeile from '../hinweisleiste/HinweisZeile';
import { ZEILE_CSS } from '../hinweisleiste/stil';

/** Ein Hinweis, wie ihn die 404 auf dem Server vorbereitet: Text schon in der Sprache der Seite. */
export interface FehlerseitenHinweis {
  id: number;
  style: string;
  title: string | null;
  message: string;
}

interface Eigenschaften {
  hinweise: readonly FehlerseitenHinweis[];
  mehr: string;
  weniger: string;
}

/**
 * Die Hinweisleiste der serverseitigen 404 (`app/(fehler)/nicht-gefunden`).
 *
 * Die 404 entsteht ohne die App (kein Provider, kein Router), `BannerStrip`
 * läuft hier also nicht. Sie zeigt nur Hinweise, die niemand wegklicken kann
 * (Beta — Fleet-Kanon 17.10.2026 —, oder von der Verwaltung so eingestellt):
 * Ein gemerktes Schliessen liegt im Browser, das kann eine Seite vom Server
 * nicht ehren. Kein Knopf zur Registrierung — ob sie offen ist, sagt erst die
 * App (`useAnmeldeFreigabe`).
 */
export default function HinweisLeisteFehlerseite({ hinweise, mehr, weniger }: Eigenschaften) {
  if (hinweise.length === 0) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {hinweise.map((h) => (
        <HinweisZeile key={h.id} stil={h.style} titel={h.title} nachricht={h.message} mehr={mehr} weniger={weniger} />
      ))}
      <style>{ZEILE_CSS}</style>
    </div>
  );
}
